import React from 'react';
import { UseFormRegister, UseFormWatch } from 'react-hook-form';
import { RadioInput } from 'components/form';
import styles from './styles.module.scss';
import { QUESTION_CARD_BASE, QUESTION_TITLE } from '../card-classes';

interface Option {
  label: string;
  value: string;
}

interface QuestionScaleProps {
  register: UseFormRegister<any>;
  watch: UseFormWatch<any>;
  errors: any;
  name: string;
  options: Option[];
  questionText: string;
  questionNumber: number;
  containerClassName?: string;
  titleClassName?: string;
  radioContainerClassName?: string;
}

export const QuestionScale: React.FC<QuestionScaleProps> = ({
  register,
  watch,
  errors,
  name,
  options,
  questionText,
  questionNumber,
  containerClassName,
  titleClassName,
  radioContainerClassName,
}) => {
  const selectedOptions = watch(name) || [];
  const selectedValues = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions].filter(Boolean);

  // This card widens its padding at its own 960px breakpoint, not the 768px the
  // other question types use, so the scale row has room first.
  return (
    <div className={`${QUESTION_CARD_BASE} min-[961px]:pt-5 min-[961px]:pb-3 ${containerClassName || ''}`}>
      <h3 className={`${QUESTION_TITLE} ${titleClassName || ''}`}>
        {questionNumber}. {questionText}
      </h3>
      <RadioInput
        register={register}
        name={name}
        options={options}
        type="checkbox"
        parentClassName={`${styles.scaleOptionsContainer} ${radioContainerClassName || ''}`}
        validatorMessage={errors?.[name]?.message}
        disabled={selectedValues.length >= 1}
        checkValue={selectedValues}
      />
    </div>
  );
};